if (!customElements.get('essential-addon-accordion')) {
  customElements.define('essential-addon-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.content = this.querySelector('[data-addon-content]');
      this.heading = this.querySelector('[data-addon-toggle]');
      if (!this.content || !this.heading) return;
      this.expanded = false;
      const lang = document.documentElement.lang.split('-')[0];
      this.labels = ({de:['Mehr anzeigen','Weniger anzeigen'],nl:['Meer tonen','Minder tonen'],da:['Vis mere','Vis mindre'],pl:['Pokaż więcej','Pokaż mniej'],lv:['Rādīt vairāk','Rādīt mazāk']})[lang] || ['Show more','Show less'];
      this.observer = new MutationObserver(() => this.update());
      this.update();
    }
    update() {
      this.observer.disconnect();
      const app = this.content.querySelector('essential-upsell-product-addon-app-block');
      if (app) {
        const cards = Array.from(app.querySelectorAll('[data-essential-upsell-element="product"]')).filter(card => card.querySelector('input[type="checkbox"]'));
        this.content.hidden = false;
        this.classList.toggle('has-addons', cards.length > 0);
        this.classList.toggle('addons-empty', cards.length === 0);
        if (cards.length && this.heading.tagName === 'BUTTON') {
          const heading = document.createElement('h3');
          heading.className = 'essential-addon-accordion__heading';
          heading.setAttribute('data-addon-toggle', '');
          heading.textContent = this.heading.textContent.trim();
          this.heading.replaceWith(heading);
          this.heading = heading;
        }
        this.heading.hidden = cards.length === 0;
        if (cards.length > 3 && !this.moreButton) {
          this.moreButton = document.createElement('button');
          this.moreButton.type = 'button';
          this.moreButton.className = 'essential-addon-accordion__more';
          this.moreButton.setAttribute('aria-controls', this.content.id);
          this.moreButton.addEventListener('click', () => {
            const startHeight = this.content.getBoundingClientRect().height;
            this.expansionAnimation?.cancel();
            this.expanded = !this.expanded;
            this.update();
            const endHeight = this.content.getBoundingClientRect().height;
            if (this.content.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              this.expansionAnimation = this.content.animate(
                [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
                { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' }
              );
            }
          });
          this.append(this.moreButton);
        }
        cards.forEach((card, index) => card.classList.toggle('sbs-addon-hidden', index >= 3 && !this.expanded));
        this.content.style.height = '';
        if (cards.length > 3 && !this.expanded) {
          const lastCard = cards[2].getBoundingClientRect();
          const contentBox = this.content.getBoundingClientRect();
          this.content.style.height = Math.ceil(lastCard.bottom - contentBox.top) + 'px';
        }
        if (this.moreButton) {
          this.moreButton.hidden = cards.length <= 3;
          this.moreButton.setAttribute('aria-expanded', String(this.expanded));
          this.moreButton.textContent = this.labels[this.expanded ? 1 : 0];
        }
      }
      this.observer.observe(this.content, {childList:true, subtree:true});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.expansionAnimation?.cancel();
      this.observer = null;
    }
  });
}
